import { render, staticRenderFns } from "./btnsortingAction.vue?vue&type=template&id=ee2973a2&scoped=true"
import script from "./btnsortingAction.vue?vue&type=script&lang=js"
export * from "./btnsortingAction.vue?vue&type=script&lang=js"
import style0 from "./btnsortingAction.vue?vue&type=style&index=0&id=ee2973a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2973a2",
  null
  
)

export default component.exports